import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';

import { Box, Button, Stack } from '@src/components';

import useAbsencesTimeline from '../../../hooks';


export default function MonthSwitcher({ currentDates}) {
  const { calendar } = useAbsencesTimeline();
  const month = dayjs(currentDates.start).format('MMMM YY');

  const switchMonth = (delta) => {
    const date = currentDates.start;
    calendar.gotoDate(new Date(date.getFullYear(), date.getMonth() + delta, date.getDate()));
  };
  const onPrev = () => switchMonth(-1);
  const onNext = () => switchMonth(1);
  const onMonth = () => calendar.setMonthView();


  return (
    <Box sx={StyleSheet.container}>
      <Stack spacing={1} alignItems="center" direction="row">
        <Button
          sx={StyleSheet.control}
          onClick={onPrev}
          startIcon={<ArrowBackIosNewIcon fontSize="small" />}
        />

        <Button sx={StyleSheet.control} onClick={onMonth}>
          <Typography variant="h3" sx={StyleSheet.month}>{month}</Typography>
        </Button>

        <Button
          sx={StyleSheet.control}
          onClick={onNext}
          endIcon={<ArrowForwardIosIcon fontSize="small" />}
        />
      </Stack>
    </Box>

  );
}

const StyleSheet = {
  container: (theme) => ({
    background: theme.palette.grey[600],
    width: 'fit-content',
  }),
  control: (theme) => ({
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
      fill: theme.palette.common.white,
    },
    padding: 0,
    minWidth: '60px',
  }),
  month: (theme) => ({
    color: theme.palette.common.white,
  }),
};
